/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CatalogApartmentLayout.vue?vue&type=template&id=de9d6626"
import script from "./CatalogApartmentLayout.vue?vue&type=script&lang=ts"
export * from "./CatalogApartmentLayout.vue?vue&type=script&lang=ts"
import style0 from "./CatalogApartmentLayout.vue?vue&type=style&index=0&id=de9d6626&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports